import { render } from "./CRMDashboardCRMLocalitySummaryComponent.vue?vue&type=template&id=a8b7882c&scoped=true"
import script from "./CRMDashboardCRMLocalitySummaryComponent.vue?vue&type=script&lang=js"
export * from "./CRMDashboardCRMLocalitySummaryComponent.vue?vue&type=script&lang=js"

import "./CRMDashboardCRMLocalitySummaryComponent.vue?vue&type=style&index=0&id=a8b7882c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b7882c"]])

export default __exports__